import { Vehicle } from '@quorum/models/xs-resource';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface VehiclesState extends EntityState<Vehicle> {}

export const vehiclesAdapter: EntityAdapter<Vehicle> = createEntityAdapter<Vehicle>({
  selectId: (vehicle: Vehicle) => vehicle.id
});

export const initialState: VehiclesState = vehiclesAdapter.getInitialState({});
export const vehiclesFeatureSelector = createFeatureSelector<any>('vehicle');
export const vehiclesSelector = createSelector(
  vehiclesFeatureSelector,
  (state: any) => state.vehicles
);
export const { selectIds, selectEntities, selectAll, selectTotal } = vehiclesAdapter.getSelectors(vehiclesSelector);
